require("lightslider");

$(document).ready(function () {
    $("#sp-slider").lightSlider({
        pager: false,
        controls: false,
        item: 3,
        slideMargin: 30,
        autoWidth: false,
        enableTouch: false,
        enableDrag: false,
        responsive: [
            {
                breakpoint: 1279,
                settings: {
                    pager: true,
                    enableTouch: true,
                    enableDrag: true,
                    item: 1,
                    slideMargin: 40,
                    galleryMargin: 22,
                    autoWidth: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    pager: true,
                    enableTouch: true,
                    enableDrag: true,
                    item: 1,
                    slideMargin: 40,
                    galleryMargin: 22,
                },
            },
        ],
        onSliderLoad: function () {
            $("#sp-slider").removeClass("cS-hidden");
        },
    });

    // SET IFRAME URL FOR MEDIAS BLOC
    $("#mediaModal").on("show.bs.modal", function (event) {
        var button = $(event.relatedTarget);
        var src = button.data("src");
        var modal = $(this);
        modal.find("iframe").attr("src", src);
    });

    // REMOVE SRC URL ON CLOSE
    $("#mediaModal").on("hide.bs.modal", function (event) {
        var modal = $(this);
        modal.find("iframe").attr("src", "");
    });

    // DISPLAY FORM BEFORE DOWNLOAD >
    $("#brochure-modal").on("hidden.bs.modal", function (event) {
        console.log("in");
        window.toggleForm(event);
    });
});

// Init Google Map

window.InitGMAP = function () {
    let map;
    let mapEl = document.getElementById("map");

    map = new google.maps.Map(mapEl, {
        //center: { lat: 45.8357329, lng: 4.7705839 },
        center: {
            lat: parseFloat(mapEl.dataset.lat),
            lng: parseFloat(mapEl.dataset.lng),
        },
        zoom: 16,
        disableDefaultUI: true,
        //gestureHandling: 'none',
        zoomControl: true,
    });

    // The marker, positioned at Uluru
    const marker = new google.maps.Marker({
        position: {
            lat: parseFloat(mapEl.dataset.lat),
            lng: parseFloat(mapEl.dataset.lng),
        },
        icon: "/img/map-pin.svg",
        map: map,
    });
};

// OPEN FORM FUNCTION
window.toggleForm = function (event, typo) {
    event.stopPropagation();
    console.log(typo);

    if (typo != undefined) {
        document.getElementById("rooms").value = typo;
    }
    document.getElementById("form-contact").classList.toggle("open");
    document.querySelector("body").classList.toggle("form-open");
};

window.selectedDoc = "";

// DL PLAN PDF OR OPEN FORM
window.downloadPdf = function (e) {
    e.preventDefault();
    let target = e.target;

    if (getCookie(target.dataset.program)) {
        window.open(target.dataset.url, "_blank");
    } else {
        $("#brochure-modal").modal("show");
        window.selectedDoc = target.dataset.url;
        console.log(window.selectedDoc);
        //    setCookie(target.dataset.program, true);
    }
};

Vue.component("kelquartier", require("./components/Kelquartier.vue").default);
// TEST COMMENT autocomplete
// Vue.component(
//     "location-autocomplete",
//     require("./components/LocationAutocomplete.vue").default
// );

// const app = new Vue({
//     el: "#rootEl",
// });

/* NAV */
// $(window).scroll(function() {
//     var posScroll = $(document).scrollTop();

// TOGLE SUBNAV PROGRAMM ON SCROLL
// if (posScroll >= 10) {
//     $("header").addClass("scrollnav").fadeOut;
//     $("#sub-nav-programm ").addClass("topscrollnav").fadeIn;
// } else {
//     $("header").removeClass("noheader").fadeIn;
//     $("#sub-nav-programm ").removeClass("topscrollnav").fadeOut;
// }

// TOGGLE STICKY CONTACT ON SCROLL
// var stickyGutter = document.querySelector("aside .element-gutter");
// var stickyBottom = document.querySelector("#sticky-banner-bottom");
// var sectionPointForts = document.querySelector("#points-forts");

// if (window.innerWidth > 1023) {
//     if (
//         sectionPointForts.getBoundingClientRect().bottom <
//         window.innerHeight
//     ) {
//         stickyGutter.style.opacity = "0";
//         stickyBottom.style.opacity = 1;
//     } else {
//         stickyGutter.style.opacity = "1";
//         stickyBottom.style.opacity = 0;
//     }
// } else {
//     if (posScroll >= 10) {
//         stickyBottom.style.opacity = 1;
//     } else {
//         stickyBottom.style.opacity = 0;
//     }
// }
// });

function toggleSubMenu() {
    const subNavBarMobile = document.querySelector("#sub-nav-programm");

    subNavBarMobile.classList.toggle("menu-open");
    document.querySelector("body").classList.toggle("backdrop");
}

// CLOSING SUB NAV OPEN

const subNavItems = document.querySelectorAll(
    "#sub-nav-programm .main-nav .item-nav"
);
subNavItems.forEach(function (item) {
    item.addEventListener("click", function (event) {
        console.log(lottie.getRegisteredAnimations());
        lottie.setDirection(-1, "AnimationId1");
        lottie.play("AnimationId1");
        window.toggleMenu(true);
        // if (window.innerWidth < 1025) {
        // }
    });
});

// SCROLLto
function scrollTo(target) {
    var speed = 750;
    var windowWidth = $(window).width();

    if (windowWidth > 995) {
        $("html, body").animate(
            { scrollTop: $(target).offset().top - 150 },
            speed
        );
    } else {
        $("html, body").animate(
            { scrollTop: $(target).offset().top - 100 },
            speed
        );
    }

    return false;
}

$(".js-scrollTo").on("click", function (e) {
    e.preventDefault();

    var page = $(this).attr("href");
    var target = page.substr(page.indexOf("#"));

    if (document.querySelector(target) != null) {
        scrollTo(target);
    } else {
        window.location = page + "?scroll=1";
    }
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function eraseCookie(name) {
    document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

document.addEventListener("DOMContentLoaded", function () {
    var body = document.body;
    var header = document.querySelector("header");
    var subNavLinks = document.querySelectorAll(
        "#sub-nav-programm .js-scrollTo"
    );

    subNavLinks.forEach(function (link) {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Retirez la classe 'menu-open' de l'élément <header>
            header.classList.remove("menu-open");

            // Retirez la classe 'backdrop' du <body>
            body.classList.remove("backdrop");

            // Vous pouvez également ajouter d'autres actions spécifiques au clic ici
        });
    });
});

$(document).ready(function () {
    $(document).ready(function () {
        // Active par défaut le premier bouton et onglet
        $("#medias-visite-virtuelle #v-pills-tab button:first").addClass(
            "active"
        );
        $("#medias-visite-virtuelle .tab-pane:first").addClass("show active");

        // Gestion des clics sur les boutons
        $("#medias-visite-virtuelle #v-pills-tab button").on(
            "click",
            function () {
                // Réinitialise tous les boutons et onglets
                $("#medias-visite-virtuelle #v-pills-tab button").removeClass(
                    "active"
                );
                $("#medias-visite-virtuelle .tab-pane").removeClass(
                    "show active"
                );

                // Active le bouton cliqué
                $(this).addClass("active");

                // Affiche l'onglet correspondant
                var tabId = $(this).attr("aria-controls");
                $("#medias-visite-virtuelle #" + tabId).addClass("show active");
            }
        );
    });
});

$(document).ready(function () {
    $(document).ready(function () {
        // Active par défaut le premier bouton et onglet
        $("#medias-3d #v-pills-tab button:first").addClass("active");
        $("#medias-3d .tab-pane:first").addClass("show active");

        // Gestion des clics sur les boutons
        $("#medias-3d #v-pills-tab button").on("click", function () {
            // Réinitialise tous les boutons et onglets
            $("#medias-3d #v-pills-tab button").removeClass("active");
            $("#medias-3d .tab-pane").removeClass("show active");

            // Active le bouton cliqué
            $(this).addClass("active");

            // Affiche l'onglet correspondant
            var tabId = $(this).attr("aria-controls");
            $("#medias-3d #" + tabId).addClass("show active");
        });
    });
});

$(document).ready(function () {
    $(window).scroll(function () {
        // Hauteur du défilement du haut de la page
        var scrollTop = $(window).scrollTop();

        // Hauteur de l'élément #banner-top
        var bannerTopHeight = $("#banner-top").height();

        // Ajoutez une classe à #status lorsque le défilement dépasse la hauteur de #banner-top
        if (scrollTop > bannerTopHeight) {
            $("#status").addClass("scrolled");
        } else {
            // Supprimez la classe si le défilement est en haut de la page
            $("#status").removeClass("scrolled");
        }
    });
});

$(document).ready(function () {
    $(window).scroll(function () {
        var footerOffset = $("footer").offset().top;
        var ctaOffsetStatus = $("#status").offset().top;
        var ctaOffsetContact = $("#right-gutter").offset().top;

        // Choisissez la distance maximale
        var maxScrollDistance = footerOffset - 500;

        if ($(window).scrollTop() >= maxScrollDistance) {
            $("#status, #right-gutter").addClass("opacity-0");
        } else {
            $("#status, #right-gutter").removeClass("opacity-0");
        }
    });
});
